import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { DriverMaster } from '@/types/driverMaster'
import { Vehicle } from '@/types/vehicle'

interface ManualCompensationDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  drivers: DriverMaster[]
  vehicles?: Vehicle[]
  onSuccess?: () => void
}

export function ManualCompensationDialog({
  open,
  onOpenChange,
}: ManualCompensationDialogProps) {
  const navigate = useNavigate()

  useEffect(() => {
    if (open) {
      onOpenChange(false)
      navigate('/salaryreport/bulk-compensation')
    }
  }, [open, onOpenChange, navigate])

  return null
}